import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export interface OrderLine {
  line_id: number
  article_no: string | null
  description: string | null
  count: number | null
  price: number | null
  discount: number | null
  amount: number | null
  info: string | null
}

interface OrderLineRaw {
  line_id: number
  article_no: string | null
  description: string | null
  count: number | null
  price: number | null
  discount: number | null
  amount: number | null
  erp_raw_data: { Info?: string } | null
}

export function useOrderLines(orderId: number | null) {
  return useQuery({
    queryKey: ['dashboard-order-lines', orderId],
    queryFn: async () => {
      if (!orderId) return []

      const { data, error } = await supabase
        .schema('erp').from('order_lines')
        .select('line_id, article_no, description, count, price, discount, amount, erp_raw_data')
        .eq('order_id', orderId)
        .is('deleted_at', null)
        .order('line_id', { ascending: true })

      if (error) {
        console.error('Order lines error:', error)
        throw error
      }

      return ((data as OrderLineRaw[]) || []).map((line) => ({
        line_id: line.line_id,
        article_no: line.article_no,
        description: line.description,
        count: line.count,
        price: line.price,
        discount: line.discount,
        amount: line.amount,
        info: line.erp_raw_data?.Info || null,
      })) as OrderLine[]
    },
    enabled: !!orderId,
    staleTime: 60_000,
  })
}
